import { Default } from '../../../../../components/Blocks/Teaser/Default';

export default Default;
